import { render, staticRenderFns } from "./Operdetails.vue?vue&type=template&id=2edf8928&scoped=true&"
import script from "../js/Operdetails.js?vue&type=script&lang=js&"
export * from "../js/Operdetails.js?vue&type=script&lang=js&"
import style0 from "../styles/Operdetails.sass?vue&type=style&index=0&id=2edf8928&lang=sass&scoped=true&"
import style1 from "./Operdetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edf8928",
  null
  
)

export default component.exports